export default "__VITE_ASSET__CGxIJm0r__"